<template>
  <v-card class="card-border">
    <highcharts :options="chartOptions" ref="chart"/>
  </v-card>
</template>

<script>
import { Chart } from "highcharts-vue";
import { mapGetters } from "vuex";

export default {
  name: "LeadsByStatus",

  components: {
    highcharts: Chart
  },

  data() {
    return {
      chartOptions: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
          events: {
            load(event) {
              this.showLoading("Preencha os campos acima corretamente")
            },

            redraw(event) {
              this.hideLoading()
            }
          }
        },
        title: {
          text: "Percentual de Leads por Status"
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
        },
        accessibility: {
          point: {
            valueSuffix: "%"
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %"
            }
          }
        },
        series: [
          {
            name: "Total",
            colorByPoint: true,
            data: [
              {
                name: "Andamento",
                y: 0
              },
              {
                name: "Pendente",
                y: 0
              },
              {
                name: "Sucesso",
                y: 0
              },
              {
                name: "Encerrado",
                y: 0
              }
            ]
          }
        ],
        colors: ['#2CB2AD', '#EFC13B', '#88D956', '#CF5D47']
      }
    };
  },

  computed: {
    ...mapGetters("dashboard", ["getLeads"])
  },

  methods: {
    clearChart() {
      this.chartOptions.series[0].data.forEach(data => (data.y = 0));
    },

    generateGrafic(leads) {
      for (const lead of leads) {
        this.chartOptions.series[0].data.forEach(data => {
          data.y += 1 ? data.name === lead.status : null;
        });
      }
    }
  },

  watch: {
    getLeads(leads) {
      this.clearChart();
      this.generateGrafic(leads);
    }
  },

  mounted() {
    if (this.getLeads.length !== 0) {
      this.clearChart()
      this.generateGrafic(this.getLeads)
    }
  }
};
</script>
